import { Backdrop, CircularProgress } from '@mui/material'

export const LOADING_SCREEN_Z_INDEX = 2000

interface Props {
  show: boolean
}

export function LoadingScreen({ show }: Props) {
  return (
    <Backdrop open={show} sx={{ zIndex: LOADING_SCREEN_Z_INDEX }}>
      <CircularProgress disableShrink />
    </Backdrop>
  )
}
